// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-scanner-invite .ant-modal-body {\n  padding: 12px 24px 0;\n}\n.modal-scanner-invite .ant-modal-footer {\n  border-top: unset;\n  padding: 10px 24px 24px;\n}", ""]);
// Exports
module.exports = exports;
